import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import HeaderBackground from "../../../images/banner_administradores.jpg";
import { Grid, FormControlLabel, Switch } from "@mui/material";
import { createAAFF, getAllCommercials, getLegaliaOptions } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import { useNavigate } from "react-router-dom";
import { verificarNif, verificarCorreo, verificarTelefono, verificarCodigoPostal } from "../../../functions/validator/formValidator";
const NuevoAAFF = () => {
  const { t } = useTranslation('aaff');

  const navigate = useNavigate();
  const [aaff, setAaff] = useState({ tieneLegalia: false, legalia_id: null })
  const [comerciales, setComerciales] = useState([])
  const [listadoMunicipios, setListadoMunicipios] = useState([])
  const [provincia, setProvincia] = useState('')
  const [legaliaOptions, setLegaliaOptions] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const [response, legalias] = await Promise.all([
      getAllCommercials(),
      getLegaliaOptions(),
    ]);
    setComerciales(response)
    setLegaliaOptions(legalias || [])
  }

  const toggleLegalia = (e) => {
    const checked = e.target.checked;
    setAaff(prev => ({
      ...prev,
      tieneLegalia: checked,
      legalia_id: checked ? prev.legalia_id ?? null : null,
    }));
  };

  const handleLegaliaChange = (e) => {
    const value = e.target.value;
    setAaff(prev => ({
      ...prev,
      legalia_id: value ? parseInt(value, 10) : null,
    }));
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setAaff({
      ...aaff,
      [evt.target.name]: value,
    });

  }

  const seleccionarMunicipios = (e) => {
    let provincia = ""
    let municipios = []
    provinces.map(p => {
      if (p.code === e.target.value) {
        provincia = p.name
      }
    })
    // setProvincia(provincia)
    setAaff({
      ...aaff,
      provincia,
    });

    municipalities.map(m => {
      if (m.provCode === e.target.value) {

        municipios.push(m)
      }
    })
    setListadoMunicipios(municipios)
  }

  const crearAAFF = async (e) => {
    e.preventDefault();
    let nifCorrecto = verificarNif(aaff.nif);
    let emailCorrecto = verificarCorreo(aaff.email);
    let telefonoCorrecto = verificarTelefono(aaff.telefono);
    let codigoPostalCorrecto = verificarCodigoPostal(aaff.codigoPostal);
    let toastInfo = toast.info(t('messages.saving'));

    let errores = false;

    if (Object.keys(aaff).length === 0) {
        toast.dismiss(toastInfo);
        toast.error(t('messages.emptyAaff'));
        errores = true;
    } else {
        if (nifCorrecto === false && aaff.nif !== undefined) {
            toast.dismiss(toastInfo);
            toast.error(t('messages.incorrectNif'));
            errores = true;
        }
        if (emailCorrecto === false && aaff.email !== undefined) {
            toast.dismiss(toastInfo);
            toast.error(t('messages.incorrectEmail'));
            errores = true;
        }
        if (telefonoCorrecto === false && aaff.telefono !== undefined) {
            toast.dismiss(toastInfo);
            toast.error(t('messages.incorrectPhone'));
            errores = true;
        }

        if (codigoPostalCorrecto === false && aaff.codigoPostal !== undefined) {
          toast.dismiss(toastInfo);
          toast.error(t('messages.incorrectPostalCode'));
          errores = true;
      }

        if (!errores) {
          const response = await createAAFF(aaff);

          console.log("response.data",response.data);

          if (response.status === 403) {
              toast.update(toastInfo, {
                  render: response.data.error[0],
                  type: toast.TYPE.ERROR,
                  autoClose: true,
              });
          } else if (response.data === "ERROR_CREATE_AAFF") {
              toast.update(toastInfo, {
                  render: t('messages.createError'),
                  type: toast.TYPE.ERROR,
                  autoClose: true,
              });
          } else if (response.data === "ERROR_AAFF_EXIST") {
              toast.update(toastInfo, {
                  render: t('messages.alreadyExists'),
                  type: toast.TYPE.ERROR,
                  autoClose: true,
              });
            }
          else{
            const requiredFields = ['nif', 'email'];
          let campoVacio = false;
          for (const field of requiredFields) {
              if (!aaff[field]) {
                  campoVacio = true;
                  break;
              }
          }

          if (campoVacio) {
              toast.update(toastInfo, {
                  render: t('messages.requiredField'),
                  type: toast.TYPE.ERROR,
                  autoClose: true,
              });
          } else {


               if (response.status === 200) {
                  toast.update(toastInfo, {
                      render: t('messages.createdSuccess'),
                      type: toast.TYPE.SUCCESS,
                      autoClose: true,
                  });
                  setTimeout(() => {
                      navigate('/aaff');
                  }, 2000);
              }
          }
          }

      }

    }
};

  return (
    <>
      <BreadCrumb rutas={[{ path: '/aaff', label: t('title') }, { path: '/aaff', label: t('new') }]} style={{ margin: '0 10px' }} />
      <div className="pageContent">
        <div className="gridHead">
          {t('new')}
        </div>
        <form className="nuevoAAFFForm" onSubmit={crearAAFF}>
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('fields.nif')}
                name="nif"
                value={aaff.nif}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('fields.name')}
                name="razonSocial"
                value={aaff.razonSocial}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                placeholder={t('fields.email')}
                name="email"
                value={aaff.email}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="tel"
                placeholder={t('fields.phone')}
                name="telefono"
                value={aaff.telefono}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="provincia"
                onChange={(e) =>
                  seleccionarMunicipios(e)
                }
              >
                <option value={aaff.provincia}>{t('fields.province')}</option>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.code}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="municipio"
                onChange={handleChange}
              >
                <option value={aaff.municipio}>{t('fields.municipality')}</option>
                {listadoMunicipios.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.value}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="codigoPostal"
                placeholder={t('fields.postalCode')}
                name="codigoPostal"
                value={aaff.codigoPostal}
                onChange={handleChange}
              ></input>
            </Grid>

            <Grid item xs={12} sm={6}>
              <input
                type="text"
                placeholder={t('fields.contactPerson')}
                name="nombreContacto"
                value={aaff.nombreContacto}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                placeholder={t('details.contactEmail')}
                name="correoContacto"
                value={aaff.correoContacto}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                name="commer_id"
                onChange={handleChange}
              >
                <option value={0}>{t('common:commercials.titleSingular')}</option>
                {comerciales?.map((e, i) => {
                  return (
                    <option key={i} value={e.id}>
                      {e.nombre + " " + e.apellidos}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!aaff.tieneLegalia}
                    onChange={toggleLegalia}
                    name="tieneLegalia"
                    color="primary"
                  />
                }
                label="Legal IA"
              />
            </Grid>
            {aaff.tieneLegalia && (
              <Grid item xs={12} sm={6}>
                <select
                  name="legalia_id"
                  value={aaff.legalia_id ?? ""}
                  onChange={handleLegaliaChange}
                >
                  <option value="">Selecciona plan Legal IA</option>
                  {legaliaOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.nombre}
                    </option>
                  ))}
                </select>
              </Grid>
            )}
          </Grid>
          <input type="submit" value={t('common:actions.save')}></input>
        </form>
      </div>
    </>
  );
}

export default NuevoAAFF;